import { render, staticRenderFns } from "./Campanha.vue?vue&type=template&id=bdb26332&scoped=true&"
import script from "./Campanha.vue?vue&type=script&lang=js&"
export * from "./Campanha.vue?vue&type=script&lang=js&"
import style0 from "./Campanha.vue?vue&type=style&index=0&id=bdb26332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb26332",
  null
  
)

export default component.exports